module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-bg2.png?e0cee014";